// Section for import npm components -----------------------------------------------------------------------------------
import React from 'react';
import { createRoot } from 'react-dom/client';

// Material UI ( mui )  components
import Box from '@mui/material/Box';

// Section for import custom types -------------------------------------------------------------------------------------
import Header from '@components/layout/Header';
import Footer from '@components/layout/Footer';
import MansionNavigation from '@components/MansionNavigation';
import CitiesDescription from '@components/MansionNavigation/CitiesDescription';
import Breadcrumbs from '@components/common/Breadcrumbs';
import EstateHelpContactCta from '@components/Mansions/EstateHelpContactCta';
import App from './app';

const targetId = 'app-content-mansions';

function MansionsApp() {
  const container = document.getElementById(targetId)!;
  const { props } = container.dataset;

  const propsData = JSON.parse(props!);
  const breadcrumbs = container.dataset.breadcrumbs ? JSON.parse(container.dataset.breadcrumbs) : [];
  const { selectedCities } = propsData;
  const isCitySelectMode = selectedCities.length !== 0;
  return (
    <App>
      <Header />
      <Box>
        <MansionNavigation
          isPrefectureSelect={propsData.isPrefectureSelect}
          selectedPrefecture={propsData.selectedPrefecture}
          isCitySelect={propsData.isCitySelect}
          selectedCity={propsData.selectedCity}
          isLineSelect={false}
          selectedLine={null}
          mansionsData={propsData.mansionsData}
          typeNavigation={propsData.typeNavigation}
          navigationName="mansions"
        />
      </Box>
      {isCitySelectMode ? <CitiesDescription selectedCities={propsData.selectedCities} /> : null}
      <EstateHelpContactCta />
      <Breadcrumbs breadcrumbs={breadcrumbs} />
      <Footer />
    </App>
  );
}

// Render component if the targetId element exists in the DOM.
if (document.getElementById(targetId)) {
  const container = document.getElementById(targetId)!;
  const root = createRoot(container);
  root.render(<MansionsApp />);
}
